module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Serviços Disponíveis")]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_c('p', [_vm._v("\n    Os seguintes serviços disponíveis aos futuros e atuais Titulares de Certificados Digitais são oferecidos através das\n    "), _c('strong', [_vm._v("Autoridades de Registro (AR's)")]), _vm._v(" credenciadas:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("  "), _c('a', {
    attrs: {
      "href": "#solicitar"
    }
  }, [_vm._v("Solicitar Certificado")])]), _vm._v(" "), _c('li', [_vm._v("  "), _c('a', {
    attrs: {
      "href": "#emitir"
    }
  }, [_vm._v("Emitir Certificado")])]), _vm._v(" "), _c('li', [_vm._v("  "), _c('a', {
    attrs: {
      "href": "#testar"
    }
  }, [_vm._v("Testar Certificado")])]), _vm._v(" "), _c('li', [_vm._v("  "), _c('a', {
    attrs: {
      "href": "#renovar"
    }
  }, [_vm._v("Renovar Certificado")])]), _vm._v(" "), _c('li', [_vm._v("  "), _c('a', {
    attrs: {
      "href": "#senha"
    }
  }, [_vm._v("Alterar Senha de Revogação")])]), _vm._v(" "), _c('li', [_vm._v("  "), _c('a', {
    attrs: {
      "href": "#revogar"
    }
  }, [_vm._v("Revogar Certificado")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Para consultar a lita das Autoridades de Registro (AR's), acesse o repositório da AC desejada\n    no menu à esquerda.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "solicitar"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Solicitar Certificado Digital")])]), _vm._v(" "), _c('p', [_vm._v("\n    A pessoa que desejar um certificado digital deve escolher uma Autoridade de Registro (AR) e efetuar a solicitação\n    do certificado digital.\n    A solicitação pode ser feita remotamente, no site da AR, ou presencialmente em um posto de atendimento da AR.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Para validar a solicitação do certificado, o solicitante deverá comparer a um posto de atendimento da AR ou\n    solicitar uma visita de um Agente de Registro. Documentos de identificação pessoal originais devem ser apresentados.\n    Se for um certificado de pessoa jurídica, documentos de constituição e nomeação de representantes legais também\n    devem ser apresentados.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Documentos necessários da pessoa física:"), _c('br'), _vm._v("\n    - Documento de identificação"), _c('br'), _vm._v("\n    - Cadastro de Pessoa Física (CPF)"), _c('br'), _vm._v("\n    - Comprovante de Residência"), _c('br'), _vm._v("\n    - Carteira de Trabalho, se o PIS for informado"), _c('br'), _vm._v("\n    - CEI - Cadastro Especifico do INSS, se informado"), _c('br'), _vm._v("\n    - Título de Eleitor, se informado\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Documentos necessários da pessoa jurídica:"), _c('br'), _vm._v("\n    - Registro Comercial, Ato Constitutivo, Estatuto ou Contrato Social"), _c('br'), _vm._v("\n    - Cartão CNPJ"), _c('br'), _vm._v("\n    - CEI - Cadastro Especifico do INSS, se informado"), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "emitir"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Emitir Certificado Digital")])]), _vm._v(" "), _c('p', [_vm._v("\n    Após a aprovação da solicitação de certificado digital, o titular pode emitir o certificado a partir do site da\n    Autoridade de Registro (AR), informando usuário e senha pessoal.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "testar"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Testar Certificado Digital")])]), _vm._v(" "), _c('p', [_vm._v("\n    O titular pode testar o funcionamento de seu certificado digital a qualquer momento no site da Autoridade de Registro.\n    "), _c('a', {
    attrs: {
      "href": "https://arsoluti.acsoluti.com.br/auth/testeseucertificado",
      "target": "_blank"
    }
  }, [_vm._v("Clique aqui e teste agora mesmo seu certificado.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "renovar"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Renovar Certificado Digital")])]), _vm._v(" "), _c('p', [_vm._v("\n    Certificados digitais de pessoas físicas podem ser renovados sem a necessidade de comparecer a uma AR. Um certificado pode fazer\n    a renovação online uma única vez, e o pedido de renovação deve ser feito enquanto o certificado digital ainda está válido.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    O titular pode solicitar a renovação online de seu certificado digital no site da Autoridade de Registro ou utilizando o link enviado\n    no email alertando a respeito do final do prazo de validade.\n    "), _c('a', {
    attrs: {
      "href": "https://arsoluti.acsoluti.com.br/site/renovacao-online",
      "target": "_blank"
    }
  }, [_vm._v("Clique aqui e renove seu certificado.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "revogar"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Revogar Certificado Digital")])]), _vm._v(" "), _c('p', [_vm._v("\n    O titular pode revogar seu certificado digital site da Autoridade de Registro. Para isso, precisa ter em mãos o "), _c('strong', [_vm._v("código da solicitação")]), _vm._v("\n    e a "), _c('strong', [_vm._v("senha de revogação")]), _vm._v(". Estas informações estão no "), _c('strong', [_vm._v("Termo de Titularidade")]), _vm._v(" entregue\n    no momento da validação presencial, antes da emissão do seu certificado.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Se o titular não possuir mais o Termo de Titularidade, ou tiver alterado a senha de revogação, deve procurar um posto de atendimento da\n    Autoridade de Registro para solicitar a revogação. Deverá apresentar os mesmos documentos apresentados para a\n    emissão do certificado digital.\n    "), _c('a', {
    attrs: {
      "href": "https://solutitech.solutissl.com/site/revogar",
      "target": "_blank"
    }
  }, [_vm._v("Clique aqui para Revogar o seu certificado.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "senha"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Alterar Senha de Revogação")])]), _vm._v(" "), _c('p', [_vm._v("\n    Para alterar a senha de revogação do certificado digital é preciso ter em mãos o "), _c('strong', [_vm._v("código da solicitação")]), _vm._v("\n    e a "), _c('strong', [_vm._v("senha atual de revogação")]), _vm._v(". Estas informações estão no "), _c('strong', [_vm._v("Termo de Titularidade")]), _vm._v(" entregue\n    no momento da validação presencial, antes da emissão do certificado.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Se o titular não possuir mais o Termo de Titularidade, ou tiver alterado a senha de revogação, deve procurar um posto de atendimento da\n    Autoridade de Registro para solicitar a alteração da senha. Deverá apresentar os mesmos documentos apresentados para a\n    emissão do certificado digital.\n  ")]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08d751a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Servicos.vue
// module id = 90
// module chunks = 0